angular.module('aq.filters.formatters')
.filter('number', function() {
    return function(input, format) {
        if (_.isUndefined(input) || _.isNull(input)) {
            return 0;
        }
        return numeral(input).format(format);
    };
 });
